import apiFetch from '../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `documentHistorical/all?dossierId=${dossierId}`, method: 'GET', token: token })
}
